import { useTenantContext } from '../tenant-context';

export const DEFAULT_LANGUAGE_TAG = 'en-US';

export const useLanguageTag = (): string => {
	const tenantContext = useTenantContext();
	return (tenantContext && tenantContext.languageTag) || DEFAULT_LANGUAGE_TAG;
};
